import styled from "styled-components";
import { Checkbox, Modal } from "antd";
import { COLORS, SIZES, WEIGHT } from "../../../../layout/theme";

export const InnerForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const ProductData = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.45fr) minmax(300px, 0.8fr);
	gap: 24px;
	align-items: start;

	@media only screen and (max-width: 1100px) {
		grid-template-columns: 1fr;
	}

	.ant-form-item-explain-error {
		white-space: nowrap;
		font-size: 12px;
	}

	.ant-input,
	.ant-input-affix-wrapper,
	.ant-input-number,
	.ant-select-selector {
		min-height: 42px !important;
		border-radius: 12px !important;
		border: 1px solid #d1d5db !important;
		box-shadow: none !important;
		background: #fff !important;
	}

	.ant-input-number-input {
		height: 40px;
	}

	.ant-input:hover,
	.ant-input-affix-wrapper:hover,
	.ant-input-number:hover,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
	}

	.ant-input:focus,
	.ant-input-focused,
	.ant-input-affix-wrapper-focused,
	.ant-input-number-focused,
	.ant-select-focused .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08) !important;
	}
`;

export const PublishSettings = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.45fr) minmax(300px, 0.8fr);
	gap: 24px;
	align-items: start;

	@media only screen and (max-width: 1100px) {
		grid-template-columns: 1fr;
	}
`;

export const InnerBlocks = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const DistributorImage = styled.img`
	width: 40px;
	height: 40px;
	object-fit: contain;
`;

export const Container = styled.div`
	position: sticky;
	top: 16px;
	background: ${COLORS.White};
	border: 1px solid #e5e7eb;
	border-radius: 18px;
	padding: 20px;
	box-shadow: 0 6px 22px rgba(15, 23, 42, 0.08);
`;

export const AntdCheckbox = styled(Checkbox)``;

export const LinkBrand = styled.span`
	color: ${COLORS.Grey};
	font-weight: ${WEIGHT.ExtraBold};
	font-size: ${SIZES.level7};
	line-height: 1.5;
	cursor: pointer;
`;

export const CardContainer = styled.div`
	background-color: ${COLORS.White};
	border: 1px solid #e5e7eb;
	border-radius: 18px;
	padding: 20px;
	box-shadow: 0 6px 22px rgba(15, 23, 42, 0.06);

	.ant-card {
		border: none !important;
		box-shadow: none !important;
		border-radius: 18px !important;
	}

	.ant-card-head {
		border-bottom: 1px solid #eef2f7 !important;
		padding: 0 22px !important;
		min-height: 62px;
	}

	.ant-card-head-title {
		padding: 18px 0 !important;
	}

	.ant-card-extra {
		padding: 14px 0 !important;
	}

	.ant-card-body {
		padding: 22px !important;
	}

	.ant-divider {
		margin: 18px 0;
	}

	.ant-switch {
		background: #cbd5e1;
	}

	.ant-switch-checked {
		background: ${COLORS.Default} !important;
	}

	.ant-select-multiple .ant-select-selection-item {
		background: ${COLORS.Secondary};
		color: ${COLORS.White};
		font-weight: 400;
		border-radius: 8px;
	}

	.ant-select-multiple .ant-select-selection-item-remove {
		color: ${COLORS.Black};
	}
`;

export const Section = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
	gap: 14px;
	width: 100%;
	height: 404px;
	overflow: auto;
`;

export const AntdModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 18px;
		overflow: hidden;
	}

	.ant-modal-header {
		border-bottom: 1px solid #eef2f7;
		padding: 18px 22px;
	}

	.ant-modal-body {
		background-color: ${COLORS.LightGrey};
		padding: 20px;
	}

	.ant-modal-footer {
		display: none;
	}
`;

export const InfoContainer = styled.div`
	background-color: white;
	border-radius: 16px;
	padding: 20px;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;
	background-color: ${COLORS.White};
	border: 1px solid #e5e7eb;
	border-radius: 18px;
	padding: 10px 20px;
	box-shadow: 0 6px 22px rgba(15, 23, 42, 0.06);

	.ant-picker,
	.ant-select-selector {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: ${COLORS.DarkGrey} !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;
